module.exports = __webpack_public_path__ + "img/backyard-planter-wide.de2b1cd3.jpg";